<template>
  <div class="dealers-edit-view">
    <form-modal
      :hide-secondary-button="true"
      primary-button-label="Editar distribuidor"
      modal-title="Editar distribuidor"
      @closeModal="onCloseModal"
      @primaryButtonClick="onSave">
      <div class="content">
        <dealers-form
          ref="form"
          :old-model="model"
        />
      </div>
    </form-modal>
  </div>
</template>

<script>
import FormModal from '@/components/_shared/form-modal'
import DealersForm from '@/modules/dealers/dealers-form'
import store from '@/store'

/**
   * 'DealersEditView' Component
   * @version 1.0.0
   * @author Fernando Torres
   * @copyright Marciano Studio S.C., 2018
   */
export default {
  name: 'DealersEditView',
  components: {FormModal, DealersForm},
  computed: {
    model () {
      return this.$store.getters['dealers/item']
    }
  },
  methods: {
    onCloseModal () {
      this.$router.push({name: 'dealers'})
    },
    onSave () {
      this.$refs.form.onSubmit()
    }
  },
  beforeRouteEnter (to, from, next) {
    store.dispatch('dealers/get', {id: to.params.id})
      .then(next)
      .catch(next)
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
  .content {
    padding: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/app/dealers/dealers-edit-view.vue